import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
    selector: "[window-type-3]",
    templateUrl: "./window-type-3.component.html",
    styleUrls: ["./window-type-3.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WindowType3Component {
  height = input<number>();

  leftWindowPositions = computed(() =>
    this.generateWindows({
      rows: Math.floor(this.height() / 50),
      xStart: 18,
      yStart: 130,
      rowMargin: 30,
      middleWindowMargin: 25,
    })
  );

  rightWindowPositions = computed(() =>
    this.generateRightWindows({
      rows: Math.floor(this.height() / 50),
      xStart: 125,
      yStart: 155,
      aStart: 145,
      bStart: 143,
      cStart: 165,
      dStart: 131,
      rowIncrement: 30,
    })
  );

  /**
   * Generates window positions for the left side.
   * @param config - Configuration object containing window parameters
   * @returns Array of window positions
   */
  private generateWindows(config: {
    rows: number;
    xStart: number;
    yStart: number;
    rowMargin: number;
    middleWindowMargin: number;
  }) {
    const { rows, xStart, yStart, rowMargin, middleWindowMargin } = config;

    return Array.from({ length: rows }, (_, rowIndex) => {
      const x = xStart;
      const y = yStart + rowIndex * rowMargin - 10;
      const b = yStart + rowIndex * middleWindowMargin + 10;
      return { x, y, a: x + 20, b, c: x + 64, d: y + 35 };
    });
  }

  /**
   * Generates window positions for the right side.
   * @param config - Configuration object containing right window parameters
   * @returns Array of window positions
   */
  private generateRightWindows(config: {
    rows: number;
    xStart: number;
    yStart: number;
    aStart: number;
    bStart: number;
    cStart: number;
    dStart: number;
    rowIncrement: number;
  }) {
    const { rows, xStart, yStart, aStart, bStart, cStart, dStart, rowIncrement } = config;

    return Array.from({ length: rows }, (_, rowIndex) => ({
      x: xStart,
      y: yStart + rowIndex * rowIncrement,
      a: aStart,
      b: bStart + rowIndex * rowIncrement,
      c: cStart,
      d: dStart + rowIndex * rowIncrement,
    }));
  }

  trackByIndex(index: number) {
    return index;
  }
}
